import React from 'react'
import { Card, CardBody, CardExpandToggler } from '../other/card/card'
import CampaignCard from '../other/card/campaignCard'
import ComponentLoader from '../other/ComponentLoader'
import { useGetTopCampaignsQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice'

const TopCampaigns = () => {
    const { data, isFetching } = useGetTopCampaignsQuery();

    return (
        <div className="col-xl-12 col-lg-6 ">
            <Card className="mb-3 min-h-[382px]">
                <CardBody className="relative p-0">
                    {isFetching ? <ComponentLoader /> : null}
                    <div className='p-4'>
                        <div className="d-flex fw-bold small mb-3">
                            <span className="flex-grow-1">Top Campaings</span>
                            <CardExpandToggler />
                        </div>
                        <div className='flex gap-4 flex-wrap justify-center'>
                            {Array.isArray(data) && data.map((item) => (
                                <CampaignCard type={"top"} item={item} key={item.campaign_id} />
                            ))}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default TopCampaigns
